module.exports = __webpack_public_path__ + "media/images/location-small-04697b6dd36562f578d690eab648b198.svg";